<template>
  <div class="panel__feedback">
    <div v-if="acknowledgementText" class="panel__rating-ackno">
      <!--eslint-disable vue/no-v-html-->
      <p v-html="formatMessage(acknowledgementText)"></p>
      <!--eslint-disable vue/no-v-html-->
    </div>
    <div class="panel__feedback-help">{{ feedback.length }} / {{ maxLength }}</div>
    <textarea
      ref="feedback"
      v-model="feedback"
      :maxlength="maxLength"
      class="panel__feedback-textarea"
      type="text"
      :placeholder="$t('feedback_panel.feedback_textarea_placeholder')"></textarea>
    <button
      class="panel__feedback-button"
      type="button"
      :disabled="feedback.length > maxLength"
      @click.prevent="$emit('sendFeedback', feedback)">
      <i class="fa fa-paper-plane"></i>
      {{ $t('feedback_panel.send') }}
    </button>
  </div>
</template>
<script>
// Dependencies
import { mapGetters } from 'vuex'
// Config
import config from '@/config/rating'
import { mixin } from '@/lib/utils'
export default {
  name: 'Feedback',
  mixins: [mixin],
  props: {
    selectedRatingValue: { type: Number, default: null }
  },
  data() {
    return {
      feedback: '',
      maxLength: config.MAX_FEEDBACK_LENGTH
    }
  },
  computed: {
    ...mapGetters({
      localizedAcknowledgementTexts: 'localizedAcknowledgementTexts',
      locale: 'locale'
    }),
    acknowledgementText() {
      return this.getAcknowledgementText()
    }
  },
  watch: {
    selectedRatingValue: {
      immediate: true,
      handler(newValue, oldValue) {
        this.focusTextarea()
      }
    }
  },
  mounted() {
    this.focusTextarea()
    this.$nextTick(() => {
      document.getElementById('chatList').scrollTop = document.getElementById('chatList').scrollHeight
    })
  },
  methods: {
    focusTextarea() {
      this.$nextTick(() => {
        this.$refs.feedback.focus()
      })
    },
    getAcknowledgementText() {
      const localAcknowledgements = this.localizedAcknowledgementTexts[this.locale]
      const rating = localAcknowledgements.find(
        localAcknowledgement => localAcknowledgement.ratingValue === this.selectedRatingValue
      )
      return rating ? rating.acknowledgementText : ''
    }
  }
}
</script>
<style>
.panel__feedback-button {
  padding: 10px;
  border-radius: 5px;
  background-color: #1d76ea;
  color: white;
  border: none;
  height: 100%;
  cursor: pointer;
}
.panel__feedback-button:disabled {
  background-color: #74a9ed;
  cursor: default;
}
.panel__feedback-button i {
  margin-right: 5px;
}
.panel__feedback-help {
  text-align: right;
}
.panel__feedback-textarea {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  font-family:
    -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol';
  margin-bottom: 10px;
}
.panel__rating-ackno {
  padding: 10px;
  background-color: #e2ebf9;
  border-radius: 6px;
  margin: 10px 0;
  max-width: max-content;
  display: inline-block;
}
</style>
